import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../../config/reduxIndex';
import PMTaskGroup from './PMTaskGroup';
import { Button } from "@blueprintjs/core";
import { makeRandomString } from '../../../../utilities/Utility';

class PMTaskGroups extends Component {
	state = {
		isLoading: false,
		columnBy: 'project'
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter() {
		const p = this.props;
		let currentItem = p.reduxData.storedPhases[this.props.reduxData.currentPhase];
		let role = p.reduxData.currentUserRole;
		const colParam = p.colParam;

		this.setState(function () {
			return {
				isLoading: true
			}
		});

		let filtered = p.reduxData.storedTaskGroups.filter(g => g.parentID === currentItem.uniqueID);
		let distinct = [...new Set(filtered.map(x => x[colParam]))];

		this.setState(function () {
			return {
				columnBy: colParam,
				isLoading: false,
				filteredGroups: filtered,
				distinctColumns: distinct,
				currentItem: currentItem,
				currentUserRole: role
			}
		});
	}

	render() {

		const { isLoading, filteredGroups, distinctColumns, currentUserRole } = this.state;
		const addNewTask = this.addNewTask;
		const selectEditTask = this.selectEditTask;
		const selectEditTaskGroup = this.selectEditTaskGroup;
		const moveTask = this.moveTask;
		const pmProps = {
			isLoading,
			addNewTask,
			selectEditTask,
			selectEditTaskGroup,
			moveTask,
			currentUserRole
		}

		return <div className={"PMTaskGroups"}>
			{filteredGroups.map((col, i) => (
				<PMTaskGroup
					key={'_column_' + distinctColumns[i]}
					columnTitle={col.display}
					taskGroup={col}
					tasks={this.props.reduxData.storedTasks}
					colIndex={i}
					{...pmProps}
				/>
			))}

			<div className={"PMTaskGroupAdd"}>
				<Button
					icon="plus"
					title="Add New Task Group"
					intent="success"
					onClick={this.addNewTaskGroup}
				>
					New Task Group
				</Button>
			</div>
		</div>
	}

	selectEditTaskGroup = (taskGroup) => {
		let newTG = Object.assign({}, taskGroup);
		this.props.setAttributeByObj({
			overlayEditType: 'taskgroup-edit',
			temp: newTG
		});
		this.props.openOverlay("pmEdit");
	}

	addNewTaskGroup = () => {
		let newTG = {
			uniqueID: makeRandomString(24),
			parentID: this.state.currentItem.uniqueID,
			display: " ... ",
			description: ' ... ',
			phase: this.state.currentItem.display,
			hourLines: [],
			dueDate: '',
			bp: this.state.currentItem.bp,
			tasks: [],
			status: 'planned',
			assigned: []
		}

		this.props.addTaskGroup(newTG);
	}

	addNewTask = (obj) => {
		let newTask = {
			uniqueID: makeRandomString(24),
			parentID: obj.uniqueID,
			phaseID: obj.parentID, // IMPORTANT: bridge between task and phases when there is no taskGroup
			display: 'new task',
			description: ' description of task ',
			bp: obj.bp,
			project: obj.project,
			phase: obj.phase,
			hourLines: [],
			generalNotes: '.. general work notes',
			devNotes: ".. dev notes",
			leadNotes: " .. lead notes",
			status: 'ready',
			assigned: [],
			subTasks: [],
			comments: []
		}

		this.props.setAttributeByObj({
			overlayEditType: 'task',
			temp: newTask
		});

		this.props.openOverlay("pmTaskEdit");
	}

	selectEditTask = (task) => {
		let newTask = JSON.parse(JSON.stringify(task));
		this.props.setAttributeByObj({
			overlayEditType: 'task-edit',
			temp: newTask
		});
		this.props.openOverlay("pmTaskEdit");
	}

	moveTask = (sourceTask, destinationGroup, ) => {
		const p = this.props;

		let originalTG = sourceTask.parentID;

		let from = p.reduxData.storedTaskGroups.findIndex(indexOfFromTG);
		let fromTG = p.reduxData.storedTaskGroups[from];

		let to = p.reduxData.storedTaskGroups.findIndex(indexOfTG);
		let toTG = p.reduxData.storedTaskGroups[to];

		// change tasks parentID
		let copy = Object.assign({}, sourceTask)
		copy.parentID = destinationGroup.uniqueID;
		this.props.updateTask(copy);

		// remove tasks uniqueID from original taskGroup
		let oldTG = Object.assign({}, fromTG);
		oldTG.tasks = oldTG.tasks.filter(task => task !== sourceTask.uniqueID);
		//console.log(oldTG.tasks)
		this.props.updateTaskGroup(oldTG);

		// add task to destination taskGroup tasks array
		let destTG = Object.assign({}, toTG);
		destTG.tasks = [...destTG.tasks, sourceTask.uniqueID];
		//console.log(destTG.tasks)

		this.props.updateTaskGroup(destTG);

		function indexOfFromTG(tg) {
			return tg.uniqueID === originalTG;
		}

		function indexOfTG(tg) {
			return tg.uniqueID === destinationGroup.uniqueID;
		}

	}
}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		openOverlay: (obj) => {
			dispatch(actions.globalState.openOverlay(obj));
		},
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		addTaskGroup: (obj) => {
			dispatch(actions.pm.addTaskGroup(obj))
		},
		addTask: (obj) => {
			dispatch(actions.pm.addTask(obj))
		},
		updateTaskGroup: (obj) => {
			dispatch(actions.pm.updateTaskGroup(obj))
		},
		updateTask: (obj) => {
			dispatch(actions.pm.updateTask(obj))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMTaskGroups);


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/TaskGroup/PMTaskGroups.js